<!--页头-->
<template>
	<div class="w color-255 header-bg" :style="showPCNav?'top:0':'top:-100%'">
		<div class="c flex-align-center flex-between header media-cheader-header">
			<div class="flex-align-center header-logo media-cheader-logo">
				<img :src='require("./images/header-logo.png")' />
			</div>
			<div class="media-cheader-li">
				<ul class="font-18 clear">
					<li class="li"><a href="./index.html" class="color-255">首页</a></li>
					<li class="li"><a href="./about.html" class="color-255">关于我们</a></li>
					<li class="li"><a href="./qualityAssurance.html" class="color-255">品质保证</a></li>
					<li class="li"><a href="./productRange.html" class="color-255">产品系列</a></li>
					<li class="li"><a href="./joinUs.html" class="color-255">加入我们</a></li>
				</ul>
			</div>
			
			<div class="phone-icon">
				<img :src='require("./images/phone-nav.png")' @click="toggleNav"
					style="width: 25px;height: 25px;margin-right: 15px;margin-top: 15px;"/>
			</div>
			
			<div class="phone-nav " :class="showNav?'':'phone-nav-hide'">
				<ul class="font-18 clear color-101">
					<li class="li"><a href="./index.html" class="color-255">首页</a></li>
					<li class="li"><a href="./about.html" class="color-255">关于我们</a></li>
					<li class="li"><a href="./qualityAssurance.html" class="color-255">品质保证</a></li>
					<li class="li"><a href="./productRange.html" class="color-255">产品系列</a></li>
					<li class="li"><a href="./joinUs.html" class="color-255">加入我们</a></li>
				</ul>
			</div>
			
		</div>
	
		
	</div>
</template>

<script>
	var that,scrollTimer;
	export default {
		data(){
			return{
				showNav:false,
				showPCNav:true
			}
		},
		mounted() {
		  this.$nextTick(function () {
		  	that = this;
		  	window.addEventListener('scroll',()=>{
					var width = that.$utils.windowWidth;
					if(width>800){
						var y = window.scrollY;
						if(scrollTimer){
							clearTimeout(scrollTimer);
						}
						scrollTimer = setTimeout(function(){
							if(y>400){
								that.showPCNav = false;
							}else{
								that.showPCNav = true;
							}
						},100)
					}
				})
		  })
		},
		methods:{
			toggleNav:function(){
				this.showNav = !this.showNav
			}
		}
	}
	
</script>

<style scoped="scoped">
	.header{height: 106px;}
	.header-bg{background: url('./images/head-bg.png') no-repeat center;background-size: 100% 100%;height: 140px;
	position: fixed;width: 100%;left: 50%;top: 0;z-index: 999;transition: all ease-in-out 0.5s;transform: translateX(-50%);}
	.li{display: inline-block;float: left;text-align: center;border-right: 1px solid;position: relative;cursor: pointer;padding: 0 25px;}
	.li:last-child{border-right: none;}
	
	.phone-nav,.phone-icon{display: none;}
	@media screen and (max-width: 800px) {
		.phone-icon{display: block;}
		.header-bg{height: 80px;left: 0;transform: none;}
		.media-cheader-li{display: none;}
		.media-cheader-logo img{margin-left: 20px;width: 120px;margin-top:12px}
		.header{height: auto;}
		.phone-nav{display: block;width: 100%;background: url('./images/head-bg.png') no-repeat center;background-size: 100% 100%;position: fixed;left: 0;top: 58px;padding: 15px 0;
		transition: all ease-in-out 0.5s;padding-bottom: 80px;}
		.phone-nav li{list-style: none;border-right: none;line-height: 40px;}
		.phone-nav li,a{display: block;color: rgba(255,255,255,0.8);width: 100%;padding: 0;}
		
		.phone-nav-hide{top: -100%;}
	}
	
</style>